module.exports = __webpack_public_path__ + "img/benefit-05-iot-5.67ebdf43.png";